import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import menus from "./menus.module";
import users from "./users.module";
import roles from "./roles.module";
import permissions from "./permissions.module";
import periods from "./periods.module";
import transactions from "./transactions.module";
import parameters from "./parameters.module";
import matches from "./matches.module";
import stands from "./stands.module";
import blocks from "./blocks.module";
import payments from "./payments.module";
import passoligs from "./passoligs.module";
import tickets from "./tickets.module";
import rows from "./rows.module";
import seats from "./seats.module";
import password_reset from "./password_reset.module";
import members from "./members.module";
import popups from "./popups.module";
import credits from "./credits.module";
//import ticket_requests from "./ticket_requests.module";
import sms_logs from "./sms_logs.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        htmlClass,
        config,
        breadcrumbs,
        profile,
        menus,
        users,
        roles,
        permissions,
        periods,
        transactions,
        parameters,
        matches,
        stands,
        blocks,
        payments,
        passoligs,
        tickets,
        rows,
        seats,
        password_reset,
        members,
        popups,
        credits,
        //ticket_requests,
        sms_logs
    }
});
